// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multi-line-css{\n  white-space: pre;\n}\n.realgrid-pre-wrap{\n  white-space: pre-wrap;\n}\n.excel-sub-title{\n  white-space: pre;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
